import { Autocomplete, TextField } from "@mui/material"
import { useAsyncWithStatus } from "lib/@hooks/useAsync"
import { Repeat } from "lib/@components/repeat"
import { ScheduleLibraryFolderChip } from "./schedule-library-folder-chip"

export function ConditionValueLibraryGroups({ value, onChange, loadOptions, placeholder }) {
    const { data, loading, error } = useAsyncWithStatus(loadGroups, [], placeholder)
    const folders = Array.isArray(data) ? data : []
    const selected = normaliseValue()

    return (
        <Autocomplete
            multiple
            loading={loading}
            options={folders || []}
            value={selected}
            onChange={handleChange}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            renderTags={renderTags}
            renderInput={renderInput}
        />
    )

    async function loadGroups() {
        return (await loadOptions()) || []
    }

    function renderInput(params) {
        const helperText = error ? "Unable to load library groups. Reopen the rule to retry." : ""
        return <TextField {...params} placeholder={placeholder} error={!!error} helperText={helperText} />
    }

    function normaliseValue() {
        if (!Array.isArray(value)) return []
        // Rehydrate from stored {id, name} into full folder records when present in the
        // loaded list so the rendered label always shows the current breadcrumb path.
        return value
            .map((v) => {
                if (!v || !v.id) return null
                const full = (folders || []).find(matchesFolderId(String(v.id)))
                return full || { id: String(v.id), name: v.name || v.id, path: v.name || v.id }
            })
            .filter(Boolean)
    }

    function matchesFolderId(id) {
        return function matchFolder(f) {
            return f.id === id
        }
    }

    function handleChange(_, next) {
        // Persist only id+name; path is derived from the folder list at render time.
        onChange((next || []).map((f) => ({ id: f.id, name: f.name })))
    }

    function getOptionLabel(option) {
        return option?.path || option?.name || ""
    }

    function isOptionEqualToValue(option, val) {
        return option?.id === val?.id
    }

    function renderTags(tagValue, getTagProps) {
        return <Repeat list={tagValue} item={<ScheduleLibraryFolderChip getTagProps={getTagProps} />} />
    }
}
